export function escapeHtml(value) {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;")
}

export function parseJsonScript(target) {
  if (!target) return null
  try {
    const raw = target.textContent.trim()
    return raw ? JSON.parse(raw) : null
  } catch (_e) {
    return null
  }
}
